import React from 'react';
import { connect } from 'react-redux';
import Toggle from './Toggle';
import { toast } from 'react-toastify';

const Status2FA = ({ twoFactor, onSetStatus, user }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <Toggle
        value={twoFactor}
        onToggle={e => {
          if (
            user.role === 'superAdmin'
          ) {
            onSetStatus(e);
          } else {
            toast.error('User not authorized to perform this action');
          }
        }}
      />
    </div>
  );
};
const mapStateToProps = state => {
  return {
    user: state.AppState.user,
  };
};
export default connect(mapStateToProps)(Status2FA);
